import { Link, Navigate, useLocation } from "react-router-dom";
import { Check } from "lucide-react";
import Seo from "../components/Seo";
import { formatINR } from "../data/products";

export default function OrderSuccess() {
  const { state } = useLocation();
  const order = state?.order;

  if (!order) return <Navigate to="/" replace />;

  return (
    <div className="bg-ivory" data-testid="order-success-page">
      <Seo title="Order Confirmed — Zelvoria" siteName="ZELVORIA" description="Your Zelvoria order is confirmed." />
      <div className="mx-auto flex max-w-2xl flex-col items-center px-6 py-24 text-center md:py-32">
        <span className="flex h-16 w-16 items-center justify-center rounded-full border border-gold text-gold">
          <Check size={24} strokeWidth={1.5} />
        </span>
        <p className="mt-8 text-[11px] uppercase tracking-[0.35em] text-gold">Order Confirmed</p>
        <h1 className="mt-4 font-serif text-4xl font-light text-ink md:text-5xl">
          Thank you, {order.customer.name.split(" ")[0]}.
        </h1>
        <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-taupe">
          Your order <span className="font-medium text-ink" data-testid="order-number">{order.order_number}</span> is
          being prepared with care. A confirmation will reach {order.customer.email} shortly.
        </p>

        <div className="mt-10 w-full divide-y divide-beige border-y border-beige text-left">
          {order.items.map((i) => (
            <div key={i.slug} className="flex justify-between py-4 text-sm">
              <span className="text-ink">
                {i.name} <span className="text-taupe">× {i.qty}</span>
              </span>
              <span className="text-ink">{formatINR(i.price * i.qty)}</span>
            </div>
          ))}
          <div className="flex justify-between py-4">
            <span className="text-[11px] uppercase tracking-[0.2em] text-ink">Total</span>
            <span className="font-medium text-ink" data-testid="order-total">{formatINR(order.total)}</span>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/candles"
            data-testid="continue-shopping-button"
            className="border border-cocoa px-8 py-3 text-[11px] uppercase tracking-[0.25em] text-cocoa transition-colors duration-500 hover:bg-cocoa hover:text-ivory"
          >
            Continue Shopping
          </Link>
          <Link
            to="/account"
            data-testid="view-orders-button"
            className="bg-cocoa px-8 py-3 text-[11px] uppercase tracking-[0.25em] text-ivory transition-colors duration-500 hover:bg-gold"
          >
            View Orders
          </Link>
        </div>
      </div>
    </div>
  );
}
